module.exports = __webpack_public_path__ + "img/default.5a9402a8.jpg";